module.exports = __webpack_public_path__ + "assets/355ff7ce236406e1cebb6343cee1ab91.mp3";